export default {
  computed: {
    isAllValid() {
      return Object.keys(this.form).every(key => !this.form[key].wrong);
    }
  },
  methods: {
    update(key, property, value) {
      this.form[key][property] = value;
    },
    check(key, force) {
      if (force) this.form[key].first = false;
      if (this.form[key].first) return false;
      this.form[key].wrong = false;
      this.form[key].warn = "";
      for (const valid of this.form[key].valid) {
        if (!valid.regex(this.form[key].value)) {
          this.form[key].wrong = true;
          this.form[key].warn = valid.warn(this.form[key].label);
          break;
        }
      }
    },
    checkAll(force = true) {
      Object.keys(this.form).forEach(key => {
        this.check(key, force)
      })
    }
  }
}